import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/justificativaContingencia/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.justificativaContingencia
  );

  const initials = create ? data : { ...find, ...data };

  const optionsLB = useMemo(
    () => [
      { value: 'L', label: t('s.geral.opcoes.liberado') },
      { value: 'B', label: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          descricaojustificativacontingencia: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
          statusjustificativacontingencia: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
          idcliente: client,
        };

        if (create) {
          dispatch(storeData(objSend, params));
        } else {
          dispatch(updateData(objSend, params));
        }
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [create, client, initials]
  );

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="descricaojustificativacontingencia"
            label={t(
              's.configuracao.justificativacontingencia.descricaojustificativacontingencia'
            )}
          />

          <Select
            name="statusjustificativacontingencia"
            label={t(
              's.configuracao.justificativacontingencia.statusjustificativacontingencia'
            )}
            options={optionsLB}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
